<template>
<v-card class='elevation-10' >
  <v-card-title class='overline' xs12 >{{ title }}</v-card-title>
  <slot name='alert' ></slot>
  <v-alert
    :value='true'
    v-if='left.id === right.id'
    type='success' color='success' >
    {{sameTitle}}
  </v-alert>
  <v-layout v-else >
    <v-flex xs6>
      <!-- :dark='isSelected(left)' -->
      <v-card class='ma-3' v-if='left'
        @click='$emit("input", left)' >
        <slot name='left-title' ></slot>
        <slot name='left-object' >
            <component
              v-if='displayComponent'
              :is='displayComponent'
              v-bind='displayComponentLeftAttrs' >
            </component>
            <pre v-else >
              {{ left }}
            </pre>
          </slot>
          <v-btn fab absolute top right small
            v-if='withEdit'
            @click='$emit("edit", left)'
            :loading='loading'
            class='mt-4' >
            <v-icon>edit</v-icon>
          </v-btn>
          <!-- <v-btn fab absolute top right small
            v-if='isSelected(left)'
            :loading='loading'
            class='mt-4' color='success' >
            <v-icon>check</v-icon>
          </v-btn> -->
      </v-card>
    </v-flex>
    <v-flex v-if='right' xs16 >
      <!-- :dark='value && value.id === right.id' -->
      <v-card class='ma-3'
        @click='$emit("input", right)' >
        <slot name='right-object' >
            <component class='ma-0'
              v-if='displayComponent'
              :is='displayComponent'
              v-bind='displayComponentRightAttrs' >
            </component>
            <pre v-else >
              {{ right }}
            </pre>
          </slot>
      </v-card>
    </v-flex>
  </v-layout>
</v-card>
</template>
<script>
export default {
  name: 'ObjectSelector',
  props: {
    title: { type: String, default: 'Pick one' },
    sameTitle: { type: String, default: 'Linked object is the same. No action required' },
    value: { type: Object },
    left: { required: true },
    right: { required: true },
    withEdit: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    displayComponent: { type: Object, required: false },
    displayComponentLeftAttrs: { type: Object },
    displayComponentRightAttrs: { type: Object }
  },
  computed: {
    obj () {
      return this.getObjectPath(this.fieldPath, null)
    }
  },
  methods: {
    isSelected (item) {
      if (this.value && this.value.id === item.id) {
        return true
      }
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// ObjectSelector.vue?16c48c8e